module.exports = __webpack_public_path__ + "static/media/GLOBAL-CONSEQUENCE-17.61c09fcd.png";